<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('Create', 'CybersourceProfile')" md="3">
        <b-button variant="primary" :to="{ name: 'cybersource-add' }">
          <span class="text-nowrap">Add New</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Cybersource profiles">
      <!-- search input -->
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'status'">
            <span>
              <b-badge
                v-if="props.row.status === 'Active'"
                pill
                variant="success"
              >
                Active
              </b-badge>
              <b-badge
                v-else-if="props.row.status === 'InActive'"
                pill
                variant="danger"
              >
                InActive
              </b-badge>
            </span>
          </span>

          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <span
              v-if="
                $can('Update', 'CybersourceProfile') ||
                  $can('Delete', 'CybersourceProfile')
              "
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="$can('Update', 'CybersourceProfile')"
                  variant="warning"
                  @click="editProfileModal(props.row)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('Delete', 'CybersourceProfile')"
                  variant="danger"
                  @click="handelDelete(props.row)"
                >
                  <feather-icon class="blue-icon" icon="TrashIcon" />
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template> </template
      ></vue-good-table>

      <b-modal
        id="modal-extend-orders"
        title="Are You Sure to Update Cybersource profile?"
        ok-title="Save"
        header-bg-variant="warning"
        cancel-variant="outline-secondary"
        size="lg"
        @ok="submitEditProfile"
      >
        <b-row>
          <b-form-input v-model="editProfile.id" hidden />
          <b-col md="6">
            <b-form-group label="Profile Id" label-for="profileId">
              <validation-provider
                #default="{ errors }"
                name="profileId"
                rules="required"
              >
                <b-form-input
                  id="profileId-input"
                  v-model="editProfile.profileId"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="accessKey" label-for="accessKey">
              <validation-provider
                #default="{ errors }"
                name="accessKey"
                rules="required"
              >
                <b-form-input
                  id="accessKey-input"
                  v-model="editProfile.accessKey"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Secret Key" label-for="secretKey">
              <validation-provider
                #default="{ errors }"
                name="secretKey"
                rules="required"
              >
                <b-form-input
                  id="secretKey-input"
                  v-model="editProfile.secretKey"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Merchant" label-for="name">
              <b-form-select
                id="name"
                v-model="editProfile.merchantId"
                :options="checkedmerchantIds"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  // BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  //   BFormDatepicker,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import axios from "@axios";
import store from "@/store";
import { required } from "@validations";

import { ValidationProvider } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

// const now = new Date()
// const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
// const minDate = new Date(today)
export default {
  name: "Roles",
  components: {
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    // BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    // ValidationObserver,
    // BFormDatepicker,
  },
  data() {
    return {
      required,
      isLoading: false,
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      activeRow: null,
      columns: [
        {
          label: "Profile Id",
          field: "profileId",
        },
        {
          label: "Access Key",
          field: "accessKey",
        },
        {
          label: "Secret Key",
          field: "secretKey",
        },
        {
          label: "Merchant",
          field: "merchantName",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
      searchTerm: "",
      editabelData: {},
      selectedId: 0,
      editProfile: {
        id: 0,
        merchantId: 0,
        profileId: null,
        accessKey: null,
        secretKey: null,
      },
      merchants: JSON.parse(localStorage.getItem("companies")).filter(
        (c) => c.merchants
      ),

      checkedmerchantIds: [],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    accessTypeVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-info",
        2: "light-primary",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.merchants.forEach((res) => {
      res.merchants.forEach((val) => {
        this.checkedmerchantIds.push({
          value: val.id,
          text: val.name,
        });
      });
    });
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "CybersourceProfile-View"
      );
      this.isLoading = true;
      axios
        .get("/CybersourceProfile/api/V1.0/CybersourceProfile/GetAll")
        .then((res) => {
          this.isLoading = false;
          this.rows = res.cybersourceProfiles;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    editProfileModal(row) {
      // eslint-disable-next-line prefer-destructuring
      this.editProfile = row;
      this.selectedId = row.id;
      this.$bvModal.show("modal-extend-orders");
    },
    submitEditProfile() {
      this.isLoading = true;
      axios
        .put(
          "/CybersourceProfile/api/V1.0/CybersourceProfile/Update",
          this.editProfile
        )
        .then((res) => {
          this.$swal({
            icon: "success",
            title: "Effective end date updated!",
            text: res.message,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
          if (this.dataFiltered) {
            this.filterOrders();
          } else {
            this.fetchData();
          }
        })
        .catch((res) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    handelDelete(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$http
            .delete(
              `/CybersourceProfile/api/V1.0/CybersourceProfile/Delete?id=${row.id}`
            )
            .then(() => {
              this.fetchData();
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your file has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Error: ", error);
              // this.statusMessage(err.data)
              this.isLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
